import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from './productCards/productCard';
import Section from './Section';
import ListIcon from '/fallbacks/list_icon.svg';

const ProductsList = ({ products, layoutOption, children, style }) => {
	const base = window.post_template;
	const productsIcon = base?.checkout_v3_products?.checkout_v3_products_icon
		? base?.checkout_v3_products?.checkout_v3_products_icon
		: ListIcon;
	const productsSectionTitle = base?.checkout_v3_products.tr_checkout_v3_products_selectLabel;
	const productCardType = window.post_template?.checkout_v3_products?.checkout_v3_products_radio;

	return (
		<Section heading={productsSectionTitle} icon={productsIcon} widthBorder={true}>
			<section
				className={`products__container products__container${layoutOption === 'full' ? '--full' : '--half'}`}
				style={style}
			>
				{products.map((product, index) => (
					<ProductCard
						data={{ ...product, id: index }}
						key={index}
						cardType={productCardType}
						layoutOption={layoutOption}
					/>
				))}
				{children}
			</section>
		</Section>
	);
};

ProductsList.propTypes = {
	products: PropTypes.array.isRequired,
	layoutOption: PropTypes.oneOf(['full', 'half']).isRequired,
	children: PropTypes.node,
};

export default ProductsList;
